import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { DateTime } from 'luxon';

import { TeacherLiveClassAttendeesInsertInput } from '@school_ify/schoolify-repository/src/teacher/types';

import LiveClass from '../../domain/services/bbb/meeting/Index';

interface ILiveClass {
  name: string;
  starting_at: string;
  duration: number;
  description: string;
  students: [];
}

interface ILiveClassResponse {
  id: string;
  url: string;
}

interface IInitialState {
  model: ILiveClass;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  response: ILiveClassResponse;
  error: string;
}

export const createLiveClass = createAsyncThunk('live_class/create', async (model: ILiveClass) => {
  const liveClass = new LiveClass();
  const response = await liveClass.teacherCreateMeeting(model);

  // Format data to insert students that will attend live class
  const students = model.students.map(str => {
    return {
      live_class_id: response.id,
      user_id: str,
    };
  }) as TeacherLiveClassAttendeesInsertInput[];
  await liveClass.addAttendeesToClass({ objects: students });
  return response;
});

// export const

const initialState = {
  model: {
    description: '',
    duration: 40,
    starting_at: DateTime.now().toString(),
    name: '',
    students: [],
  },
} as IInitialState;
const teacherCreateLiveClassSlice = createSlice({
  name: 'live_class',
  initialState,
  reducers: {
    setModelProp(state, payload: PayloadAction<{ prop: string; value: string | any[] }>) {
      state.model[payload.payload.prop] = payload.payload.value;
    },
    clearResponse(state) {
      state.response = {} as ILiveClassResponse;
    },
  },
  extraReducers: builder => {
    builder.addCase(createLiveClass.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(createLiveClass.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload;
    });
    builder.addCase(createLiveClass.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const exportState = state => state.teacherCreateLiveClassSlice;

export const teacherCreateLiveClassState = createSelector(exportState, obj => {
  return {
    model: obj.model,
    loading: obj.loading,
    response: obj.response,
  };
});

export const { setModelProp, clearResponse } = teacherCreateLiveClassSlice.actions;

export default teacherCreateLiveClassSlice.reducer;
